import { defineAsyncComponent } from 'vue';

const TableFilterTrackingInputer = defineAsyncComponent(() => import('./TableFilterTrackingInputer.vue'));

export default TableFilterTrackingInputer;